
import { Component, Vue, Watch } from 'vue-property-decorator';
import api from '@/modules/api';
// import { mutations } from '@/store/types';
import { DeviceInfo, DeviceType } from '@/types/device-info';
import { Firmware } from '@/types/firmware';
import { Action, State } from 'vuex-class';
import DeviceQuickActions from '@/components/quick-actions/DeviceQuickActions.vue';
import { actions } from '@/store/types';
import { UpdateDeviceActionType } from '@/types/store/actions';
import { filterObj } from '@/utils/filter-obj';
import { colorsOptions } from '@/constants/colors';
import defaultAirboltLockImage from '@/assets/default-airboltLock-image.png';
// import defaultBLEImage from '@/assets/default-ble-image.png';
import defaultCardImage from '@/assets/default-card-image.png';
import defaultGPSImage from '@/assets/default-gps-image.png';
import { getErrorMessage } from '@/utils/common';
import { upload } from '@/utils/upload-file';
import * as dlg from '@/modules/dlg';

@Component({
    components: { DeviceQuickActions },
})
export default class DeviceBasicSettings extends Vue {
    name = '';
    protected photo = '';
    ascentColor = '';
    colorsOptions = colorsOptions;
    DeviceTypeenum = DeviceType;
    currentFirmware: Firmware | null = null;
    latestFirmware: Firmware | null = null;

    @State('device')
    device!: DeviceInfo;

    @Action(actions.UPDATE_DEVICE)
    updateDevice!: UpdateDeviceActionType;

    async mounted() {
        // if (this.device.deviceType === this.DeviceTypeenum.AirboltGps) {
        //     this.getFirmwareUpdate();
        // }
    }

    updated() {
        let imagefileInput = this.$refs.imagefile as HTMLInputElement;
        imagefileInput.value = '';
    }

    get image() {
        if (this.photo) return `data:image/png;base64,${this.photo}`;
        if (this.device?.deviceType === DeviceType.AirboltTravelLock) return defaultAirboltLockImage;
        if (this.device?.deviceType === DeviceType.AirboltCard) return defaultCardImage;
        if (this.device?.deviceType === DeviceType.AirboltGps) return defaultGPSImage;
        return null;
    }

    async uploadFile({ target: { files } }: { target: { files: File[] } }) {
        if (files.length > 0) {
            const base64 = await upload(files[0]);
            if (!base64) return;
            this.photo = base64.replace(/data.*?base64,/, '');
        }
    }

    async save(e: Event) {
        e.preventDefault();
        await this.updateDevice({
            device: filterObj(
                {
                    ...this.device,
                    name: this.name,
                    devicePicture: this.photo,
                    color: this.ascentColor,
                },
                { dropNull: true, dropUndefined: true },
            ),
        });

        this.device.name = this.name;
        this.device.devicePicture = this.photo;
    }

    async getFirmwareUpdate() {
        try {
            const firmwareDetails = await api.getDeviceFirmwareUpdate(this.device.deviceUUID);
            this.currentFirmware = firmwareDetails.current || null;
            this.latestFirmware = firmwareDetails.latest || null;
        } catch (error) {
            Vue.toasted.error(getErrorMessage(error));
        }
    }

    async updateFirmware() {
        dlg.notImplemented();
        // this.$store.commit(mutations.LOADING, { loading: true });
        // try {
        //     const firmwareDetails = await api.updateDeviceFirmware(
        //         this.device.deviceUUID,
        //         this.latestFirmware?._id as string,
        //     );
        //     this.currentFirmware = firmwareDetails.current || null;
        //     this.latestFirmware = firmwareDetails.latest || null;
        //     Vue.toasted.success(`Updated successfully`);
        // } catch (error) {
        //     Vue.toasted.error(getErrorMessage(error));
        // } finally {
        //     this.$store.commit(mutations.LOADING, { loading: false });
        // }
    }

    @Watch('device', { immediate: true, deep: true })
    onDeviceChanged(device: DeviceInfo) {
        // console.log(`>> Tab updated from watcher ${this.constructor.name}`);
        if (device) {
            this.name = device.name;
            this.photo = device.devicePicture;
            this.ascentColor = device.color as string;
        }
    }
}
